<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tìm kiếm, tra cứu thông tin nhóm tài khoản đồng bộ dữ liệu</strong>
                    </div>
                    <b-form @submit.prevent="search" inline>
                        <label class="col-4 form-label d-inline text-right" for="search">Nhóm tài khoản đồng bộ dữ liệu:</label>
                        <b-form-input type="text" id="search"
                                      class="col-3 mr-sm-2"
                                      placeholder="Nhập tên nhóm tài khoản đồng bộ dữ liệu ..."
                                      v-model="searchForm.filterText">
                        </b-form-input>
                        <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                    </b-form>
                    <br />
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            dataUrl="sync-roles"
                            gridName="Danh sách nhóm tài khoản đồng bộ dữ liệu"
                            ref="syncRoleTable">
                        <template v-slot:actions v-if="authorize(['ManageSyncRole']) && isAdmin">
                            <router-link to="./create" tag="button" class="btn btn-primary" size="md">
                                Thêm mới
                            </router-link>
                            <!--<b-button size="md" @click.stop="removeSelected" variant="danger" :disabled="isShowBtnDelete">
                                Xóa
                            </b-button>-->
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button size="sm" :to="{ path: `./${row.item.id}/detail` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <template v-if="authorize(['ManageSyncRole'])">
                                    <b-button size="sm" :to="{ path: `./${row.item.id}/edit` }" title="sửa" v-if="isAdmin" variant="primary">
                                        Sửa
                                    </b-button>
                                    <b-button size="sm" @click.stop="remove(row.item, row.index, $event.target)" title="xóa" v-if="isAdmin" variant="danger">
                                        Xoá
                                    </b-button>
                                    <b-button size="sm" :to="{ path: `./${row.item.id}/privileges` }" title="phân quyền" class="mr-1" v-if="isAdmin" variant="success">
                                        Phân quyền
                                    </b-button>
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'ListSyncRole',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    filterText: null
                },
                gridOptions: {
                    fields: [
                        { key: 'name', label: 'Tên', sortable: true, sortDirection: 'asc' },
                        { key: 'description', label: 'Mô tả', sortable: false },
                    ],
                    sortBy: 'name',
                },
                isShowBtnDelete: true
            }
        },
        created() {
        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.syncRoleTable.selectedRows
                },
                (val) => {
                    this.isShowBtnDelete = val.length == 0;
                }
            )
        },
        methods: {
            search() {
                this.$refs.syncRoleTable.refresh();
            },
            remove(item, index, button) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa nhóm tài khoản đồng bộ dữ liệu này?')) {
                    this.$services.delete(`sync-roles/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa nhóm đồng bộ dữ liệu thành công');
                        vm.search();
                    });
                }
            },
            removeSelected() {
                var vm = this;
                var selectedRows = this.$refs.syncRoleTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các nhóm tài khoản đồng bộ dữ liệu này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`sync-roles?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa nhóm đồng bộ dữ liệu thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn nhóm tài khoản đồng bộ dữ liệu cần xóa');
                }
            }
        }
    }
</script>
<style scoped>
</style>
